<template>
  <v-dialog
    v-model="dialog"
    :width="step == 0? '420px': '330px'">
    <div
      class="dialog-container"
      :style="{padding:step==0?'':'15px'}">
      <template v-if="step == 0">
        <div class="plan-header">
          <div class="info flex">
            <h3>Edit Policy</h3>
          </div>
        </div>
        <div class="dialog-body">
          <el-form
            ref="form"
            :rules="rules"
            :model="formData">
            <div class="item-content">
              <div class="form-item">
                <span>Endorsement</span>
                <el-form-item
                  ref="endorse_file_path_id"
                  prop="endorse_file_path_id">
                  <v-upload
                    :card="true"
                    :fileData="formData.endorse_file"
                    :edit="true"
                    :otherData="{
                      idKey: 'endorse_file_path_id',
                      nameKey: 'endorse_file',
                      client_name:'endorse_file'
                    }"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
              <div
                class="form-item">
                <span>Pcy No.</span>
                <el-form-item
                  ref="pcy_no"
                  prop="pcy_no">
                  <v-input
                    v-model="formData.pcy_no"
                    disabled />
                </el-form-item>
              </div>
              <div
                class="form-item">
                <span>Endorsement No.</span>
                <el-form-item
                  ref="endorse_no"
                  prop="endorse_no">
                  <v-input v-model="formData.endorse_no" />
                </el-form-item>
              </div>

              <div class="form-item">
                <span>Endorsement Insured Period</span>
                <div>
                  <!--                  <el-form-item-->
                  <!--                    ref="date"-->
                  <!--                    prop="date">-->
                  <!--                    <v-date-picker-->
                  <!--                      v-model="formData.date"-->
                  <!--                      type="daterange"-->
                  <!--                    />-->
                  <!--                  </el-form-item>-->
                  <div>
                    <div class="flex flex-align">
                      <el-form-item
                        ref="endorse_ins_start_dt"
                        prop="endorse_ins_start_dt">
                        <v-date-picker
                          v-model="formData.endorse_ins_start_dt"
                        />
                      </el-form-item>
                      <span class="margin-time">To</span>
                      <el-form-item
                        ref="endorse_ins_end_dt"
                        prop="endorse_ins_end_dt">
                        <v-date-picker
                          v-model="formData.endorse_ins_end_dt"
                          disabled
                        />
                      </el-form-item>
                    </div>
                    <!--                  <span class="margin-time">To</span>-->
                    <!--                  <el-form-item-->
                    <!--                    ref="ins_end_dt"-->
                    <!--                    prop="ins_end_dt">-->
                    <!--                    <v-date-picker-->
                    <!--                      v-model="formData.ins_end_dt"-->
                    <!--                    />-->
                    <!--                  </el-form-item>-->
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="onContinue">Continue</v-button>
        </div>
      </template>
      <template v-else>
        <send-email-sms
          ref="send-email-sms"
          :initContent="endorse_sms_content"
          :form="form"
          @cancel="handleSendCancel"
          @send="onSend"
          @skip="onSkip" />
      </template>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import SendEmailSms from '@/views/records/policy/components/dialog/send-email-sms'
import {mobileEndorsePolicy, mobileMakeRefund} from '@api/micropolicy'
import MixinOptions from '@/mixins/options'

export default {
  name: 'UploadCoverNoteDialog',
  components: {
    SendEmailSms
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      step: 0,
      formData: {
        endorse_no: '',
        pcy_no: '',
        endorse_imei_no: '',
        endorse_model:'',
        endorse_brand_id:'',
        endorse_imei_path_id:'',
        endorse_file_path_id: '',
        endorse_file: {},
        endorse_buy_dt:'',
        is_send:0,
        endorse_sms_content:'',
        endorse_ins_start_dt: '',
        endorse_ins_end_dt: '',

      },
      sendFormData: {
        content: '',
        is_send:0
      },
      extraRules: {
        endorse_file_path_id: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ],
        endorse_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        endorse_ins_start_dt: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed:{
    endorse_sms_content(){
      let {endorse_sms_content,pcy_no} = this.form||{}
      let {endorse_no} = this.formData||{}
      let content = endorse_sms_content.replaceAll('{:pcy_no}',pcy_no)
      return content
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        if(!val) {
        }
        else {
          // this.formData = JSON.parse(JSON.stringify(val))
          let {pcy_no, mobile_imei_path_id,mobile_buy_dt,imei,mobile_model,mobile_brand_id,endorse_ins_start_dt,endorse_ins_end_dt,ins_end_dt} = this.form||{}
          Object.keys(this.formData).some(key=>{
            if(this.form[key])
              this.formData[key] = val[key]
          })
          this.formData.endorse_imei_path_id = this.formData.endorse_imei_path_id||mobile_imei_path_id
          this.formData.endorse_buy_dt = this.formData.endorse_buy_dt||mobile_buy_dt
          this.formData.endorse_imei_no = this.formData.endorse_imei_no||imei
          this.formData.pcy_no = this.formData.pcy_no ||pcy_no
          this.formData.endorse_model =this.formData.endorse_model||mobile_model
          this.formData.endorse_brand_id =this.formData.endorse_brand_id||mobile_brand_id
          this.formData.endorse_ins_start_dt = this.formData.endorse_ins_start_dt||endorse_ins_start_dt
          this.formData.endorse_ins_end_dt = this.formData.endorse_ins_end_dt||ins_end_dt
          if(endorse_ins_start_dt&&endorse_ins_end_dt)
            this.formData.date = [endorse_ins_start_dt,endorse_ins_end_dt]
        }
      }
    }
  },
  methods: {
    handleCancel(){
      this.dialog = false
    },
    handleSendCancel(){
      this.step = 0
    },
    changeDialog() {
      this.step = 0
      this.dialog = !this.dialog
    },
    handlerUploadSuccess({ data, result,otherData }) {
      const { type, idKey, nameKey,  urlKey, target } = otherData
      const { id, name, url,client_name } = data
      this.$set(this.formData, idKey, id)
      this.$set(this.formData, nameKey, data)
    },
    handlerDeleteFile({otherData}) {
      const { type, idKey, nameKey,  urlKey, target } = otherData
      this.$set(this.formData, idKey, '')
      this.$set(this.formData, nameKey, {})
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.step = 1
        }
        else {
          console.log(rules)
        }
      })
    },
    onSend(data) {
      this.formData.endorse_sms_content = data.content
      this.formData.is_send = 1
      this.network().mobileEndorsePolicy()
    },
    onSkip() {
      this.formData.is_send = 0
      this.network().mobileEndorsePolicy()
    },
    network() {
      return {
        mobileEndorsePolicy: async () => {
          let params = {
            order_id: this.orderId,
            ...this.formData,
            hideMessage:true
          }
          // params.endorse_ins_start_dt = this.formData.date[0]
          // params.endorse_ins_end_dt = this.formData.date[1]
          const { data } = await mobileEndorsePolicy(params).catch((err)=>{
            let {response} = err||{}
            let {data} = err.response||{}
            let {message_language,code} = data||{}
            let message = code==4806?`IMEI ${this.form.imei} is already existing.`:message_language
            this.$ConfirmBox({
              isNewConfirm:true,
              width:500,
              title:code==4806?'Existing IMEI':'Error',
              confirmBtn:code==4806?'Refund':'OK',
              isRed:true,
              message: message
            }).then(() => {
              if(code==4806){
                this.network().mobileMakeRefund()
              }
            })
          })
          this.dialog = false
          this.$emit('success',data)
        },
        mobileMakeRefund: async () => {
          const {data} = await mobileMakeRefund({
            order_id: this.orderId,
          })
          this.dialog = false
          this.$emit('success',{})
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog{
  border-radius: 6px;
}
.dialog-container {
  .dialog-body{
    padding: 15px;
  }
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border: 1px solid #E1E4E8;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .title-span{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px;
  }
  h3 {
    padding-bottom: 5px;
  }
  p {
    padding-bottom: 10px;
  }
  .dialog-footer {
    padding:0 15px 15px 15px;
    text-align: right;
    //background: #F9FAFB;
    display: flex;
    justify-content: space-between;
  }
  .form-item {
    & > span {
      //font-weight: bold;
      //font-size: 16px;
    }
  }
  .flex-align{
    align-items: center;
    .margin-time{
      margin: 0 10px;
    }
  }
}
</style>
